module.exports = __webpack_public_path__ + "img/seminar (25).e023ac35.jpg";